import { string } from 'yup';

import { driversLicenseRegexByState } from '@ourbranch/lookups';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';
import { capitalize } from 'core/helpers/formatters';

const isDriversLicenseNumValid = (licenseNumber = '', state = '') => {
  if (!state || !licenseNumber) {
    return;
  }
  const stateDriversLicenseRegex = driversLicenseRegexByState?.[state.toUpperCase()]?.regex;
  if (!stateDriversLicenseRegex) {
    return;
  }
  return stateDriversLicenseRegex.test(licenseNumber);
};

export const driversLicenseNumberSchema = string().test('is-valid-license', function (licenseNum) {
  const { parent, createError, options } = this;
  const selectedOption = options?.context?.selectedOption;
  const licenseState = parent?.driversLicenseState;
  const skipLicenseNumValidation = parent?.skipLicenseNumValidation;
  const recheckDrivingRecord = parent?.recheckDrivingRecord;
  const formattedName = `${capitalize(parent?.firstName)} ${capitalize(parent?.lastName)}`;

  // Farm-based policies (F, Z, Y) don't require driver license number validation
  if (isFarmBasedPolicyType(selectedOption)) {
    return true;
  }

  if (skipLicenseNumValidation) {
    return true;
  }

  if (recheckDrivingRecord && !licenseNum) {
    return createError({
      message: `Please provide a valid driver's license number for ${formattedName} to re-check driving record.`
    });
  }
  if (!licenseNum) {
    return true;
  }
  if (!licenseState) {
    return createError({
      message: `Please provide a license state for ${formattedName} to validate the driver's license number.`
    });
  }

  return (
    isDriversLicenseNumValid(licenseNum, licenseState) ||
    createError({
      message: `Please provide a valid driver's license number for ${formattedName}; ${licenseNum} is not valid in ${licenseState}. ${driversLicenseRegexByState?.[licenseState]?.errorMessage || ''}`
    })
  );
});
